import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite, Text } from '@pixi/react';

import { isMobile } from '../../../../core/helpers/isMobile';
import { dateHelper } from '../../../../core/helpers/timeHelper';
import { isoStandard } from '../../../../core/helpers/isoStandard';
import { getGameImages } from '../../../../core/helpers/getGameImages';
import { exchangeAmount } from '../../../../core/helpers/exchangeAmountByRate';

import { applicationStore } from '../../../../store/applicationStore';

const JackPotInfoPopup = observer(({ x, y, jackpotWinnerInfoById, selectedJackpotId }) => {
  const {
    maxWin,
    lastWin,
    totalWin,
    winsCount,
    maxWinDate,
    lastWinDate,
    jackpotCard,
    maxWinGameName,
    lastWinGameName,
  } = jackpotWinnerInfoById;
  const {
    canvasTranslationKeys: { LARGEST_WINNER, LAST_WINNER, NUMBER_OF_WINNERS },
  } = applicationStore;
  const { jackPotInfoPopup, personIcon } = useMemo(() => {
    return getGameImages();
  }, []);

  const jackPotInfoPopupTexts = useMemo(
    () => [
      {
        x: isMobile() && selectedJackpotId === 4 ? 46 : isMobile() ? 6 : 9,
        y: isMobile() ? 12 : 17,
        title: LARGEST_WINNER,
        date: dateHelper(maxWinDate),
        countOfWinners: '',
        gameName: maxWinGameName || '',
        name: 'LargestWinnerContainer',
        amount: isoStandard(exchangeAmount(maxWin)),
      },
      {
        x: isMobile() && selectedJackpotId === 4 ? 46 : isMobile() ? 6 : 9,
        y: isMobile() ? 63 : 74,
        title: LAST_WINNER,
        date: dateHelper(lastWinDate),
        countOfWinners: '',
        gameName: lastWinGameName || '',
        name: 'LastWinnerContainer',
        amount: isoStandard(exchangeAmount(lastWin)),
      },
      {
        x: isMobile() && selectedJackpotId === 4 ? 46 : isMobile() ? 6 : 9,
        y: isMobile() ? 120 : 131,
        title: NUMBER_OF_WINNERS,
        date: '',
        countOfWinners: winsCount,
        gameName: '',
        name: 'NumberOfWinnersWinnerContainer',
        amount: isoStandard(exchangeAmount(totalWin)),
      },
    ],
    [
      maxWin,
      lastWin,
      totalWin,
      winsCount,
      maxWinDate,
      lastWinDate,
      LAST_WINNER,
      LARGEST_WINNER,
      maxWinGameName,
      lastWinGameName,
      NUMBER_OF_WINNERS,
      selectedJackpotId,
    ]
  );

  const handleJackpotInfoTextStyles = (color, fontSize, fontWeight) => {
    return { fill: color, fontSize: fontSize, fontWeight: fontWeight };
  };

  return (
    <Container
      x={x}
      y={y}
      name={`JackPotInfoPopupContainer${selectedJackpotId}`}
      scale={isMobile() && selectedJackpotId === 4 ? { x: -1, y: 1 } : 1}
    >
      <Sprite texture={jackPotInfoPopup} x={isMobile() && selectedJackpotId === 4 ? -146 : 0} />
      {jackPotInfoPopupTexts.map((infoObject) => {
        const {
          date,
          name,
          title,
          amount,
          gameName,
          countOfWinners,
          x: textContainerX,
          y: textContainerY,
        } = infoObject;
        return (
          jackpotCard === selectedJackpotId && (
            <Container
              key={title}
              name={name}
              x={textContainerX}
              y={textContainerY}
              scale={isMobile() && selectedJackpotId === 4 ? { x: -1, y: 1 } : 1}
            >
              <Text
                y={0}
                text={title}
                resolution={2}
                style={handleJackpotInfoTextStyles('#FFC33E', isMobile() ? 10 : 12, 500)}
              />
              <Text
                y={isMobile() ? 15 : 19}
                text={gameName}
                resolution={2}
                style={handleJackpotInfoTextStyles('#FFFFFF', 10, 500)}
              />
              <Text
                x={!date && (isMobile() ? 15 : 24)}
                y={date ? (isMobile() ? 10 : 19) : isMobile() ? 27 : 38}
                text={countOfWinners}
                resolution={2}
                style={handleJackpotInfoTextStyles('#FFFFFF', 10, 500)}
              />
              <Text
                y={isMobile() ? 30 : 35}
                alpha={0.6}
                text={date}
                resolution={2}
                style={handleJackpotInfoTextStyles('#FFFFFF', 10, 500)}
              />
              <Text
                y={isMobile() ? 40 : 50}
                x={isMobile() ? 185 : 250}
                anchor={1}
                text={amount}
                resolution={2}
                style={handleJackpotInfoTextStyles('#FFFFFF', isMobile() ? 12 : 14, 500)}
              />
              {!date && <Sprite y={29} scale={0.5} texture={personIcon} />}
            </Container>
          )
        );
      })}
    </Container>
  );
});

export default JackPotInfoPopup;
